export const getNowAsUTCString = (): string => {
  return new Date().toISOString();
};

export const getStartOfDayISOString = (date: string): string => {
  const startOfDay: number = new Date(date).setUTCHours(0, 0, 0, 0);

  return new Date(startOfDay).toISOString();
};

export const getEndOfDayISOString = (date: string): string => {
  const endOfDay: number = new Date(date).setUTCHours(23, 59, 59, 999);

  return new Date(endOfDay).toISOString();
};
